import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Navbar from '../../Navbar';
import { profileActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';

const MyPoints = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const pointsFromStore = useSelector((state) => state.mypoints.mypoints);
    const [mypoints, setMypoints] = useState(pointsFromStore);
    const loggedUser = useLoggedUser();

    if (!loggedUser?.data?.StudentProfileID) {
        history.replace('/login');
        return null;
    }

    useEffect(() => {
        dispatch(profileActions.fetchMypoints(loggedUser.data.StudentProfileID))
            .then((response) => {
                setMypoints(response);
            })
            .catch((error) => {
                console.error('Error: ', error);
            });
    }, [dispatch, loggedUser.data.StudentProfileID]);

    useEffect(() => {
        if (pointsFromStore && !mypoints) {
            setMypoints(pointsFromStore);
        }
    }, [pointsFromStore, mypoints]);

    const points = mypoints ?? pointsFromStore;

    return (
        <React.Fragment>
            <div className="container-fluid terms-page">
                <Navbar />
                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-center flex-column">

                        <h2 className="score-h main-heading-top">
                            My Total Score: <span className="b-font"> {points?.TotalScore ?? 0}</span>
                        </h2>
                        <h2 className="score-h main-secndheading-top ml-5">
                            &nbsp; Total Coins: <span className="b-font"> {points?.AwardCoins ?? 0}</span>
                        </h2>
                        <div className="tableWrap totalscore mt-4">
                            <table className="score-table w-100">
                                <thead>
                                    <tr>
                                        <th className="r-font score-th">Game</th>
                                        <th className="r-font score-th text-center">Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {points?.data?.map((mypoint, index) => (
                                        <tr key={mypoint.GameLineID ?? `mypoint-${mypoint.GameName}-${index}`}>
                                            <td className="b-font score-td">{mypoint.GameName}</td>
                                            <td className="b-font score-td text-center">
                                                {mypoint.Score !== null ? mypoint.Score : 0}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default MyPoints;
